import { Injectable } from '@angular/core';
import { UnifiedLoginService } from './unified-login/unified-login.service';
import { TMMFeatureSet, TPTFeatureSet, TUserLoggedInInfoWithFeatureSet } from './unified-login/unified-login.types';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  constructor(private unifiedLoginService: UnifiedLoginService) {}

  isFeatureAvailable(appType: 'MM' | 'PT', feature: TMMFeatureSet | TPTFeatureSet) {
    let featureSet: TMMFeatureSet[] | TPTFeatureSet[] = this.unifiedLoginService.getFeatureSet();

    if (appType === 'MM') {
      return (featureSet as TMMFeatureSet[]).includes(feature as TMMFeatureSet);
    } else {
      return (featureSet as TPTFeatureSet[]).includes(feature as TPTFeatureSet);
    }
  }
}
